import React from 'react';

import './viaferata.styles.css'


const ViaFerrata = () => (    
    
    <div className="aaa">
        <div className="viaferrata-header">
            <div className="viaferrata-header__logo">    
                <img  className="viaferrata-header__logo-img"  alt="PK Greben" src="img/logo-greben.png"/> 
            </div>
        </div>
        <div className="viaferrata-header-main">           
            <div className="viaferrata-header-main__text-box">
                <h1 className="heading-primary viaferrata-title">
                    <span className="heading-primary--main">Via Ferrata </span>
                    <span className="heading-primary--sub">Tim</span>
                </h1>                
            </div>
        </div>
        <section className="viaferrata-description">
            <div className="viaferrata-opis">               
                <p>
                    <span className="viaferata-opis-head"> Via ferrata tim </span>je grupa licenciranih planinskih vodiča i alpinista članova PK Greben, kojima je cilj da spoje planinarenje, 
                    penjanje i avanturu i učine via ferate dostupne svima koji žele nezaboravan provod.
                </p>
                <p>
                <span className="viaferata-opis-head"> Via ferrate </span>su planinske staze obezbeđene čeličnim sajlama i pomoćnim gazištima na nepristupačnim terenima. 
                    Namenjene su svima koji žele da se penju po stenama i budu potpuno bezbedni. Postoje horizontalne i vertikalne.
                    Širom sveta, ferate privlače veliki broj planinara željnih avanture.
                </p>
            </div>
        </section>   
        <section className="viaferrata-pictures-section">       
         <div className="viaferrata-pictures-section-box">    
              <img className="viaferrata-pictures-section-box-img viaferrata-pictures-1" src="/img/ferata/ferata1.jpg" alt=""/>              
        </div>
        <div className="viaferrata-pictures-section-box">    
              <img className="viaferrata-pictures-section-box-img viaferrata-pictures-2" src="/img/ferata/ferata2.jpg" alt=""/>              
        </div>
        <div className="viaferrata-pictures-section-box">    
              <img className="viaferrata-pictures-section-box-img viaferrata-pictures-3" src="/img/ferata/ferata4.jpg" alt=""/>              
        </div>
    </section> 
    <div className="viaferata-footer">
            <p className="viaferata-footer-copywrite"> © 2020 by PK Greben</p>  
    </div>
    </div>

);


export default ViaFerrata;